var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunities = function SvgCommunities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "evenodd",
    d: "M1.041 3.5h.973c.045-.773.192-1.485.42-2.059A3 3 0 0 0 1.04 3.5M4 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 1c-.038 0-.116.016-.233.13-.118.118-.248.312-.368.592-.194.454-.337 1.07-.383 1.778h1.968c-.046-.707-.189-1.324-.383-1.778-.12-.28-.25-.474-.368-.591C4.116 1.016 4.038 1 4 1m1.986 2.5c-.045-.773-.192-1.485-.42-2.059A3 3 0 0 1 6.96 3.5zm-1.002 1H3.016c.046.707.189 1.324.383 1.778.12.28.25.474.368.591.117.115.195.131.233.131s.116-.016.233-.13c.118-.118.248-.312.368-.592.194-.454.337-1.07.383-1.778m.583 2.059c.227-.574.374-1.286.419-2.059h.973a3 3 0 0 1-1.392 2.059m-3.134 0c-.227-.574-.374-1.286-.419-2.059h-.973c.147.87.668 1.614 1.392 2.059",
    clipRule: "evenodd"
  })));
};
export default SvgCommunities;